import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY } from 'configs/AppConfig'
import { buildLoginRedirectUrl } from 'utils/redirect'

const ProtectedRoute = () => {
	const { token } = useSelector((state) => state.auth)
	const location = useLocation()

	if (!token) {
		// Remember where the user wanted to go (path + query) so PublicRoute can send them back after login.
		return <Navigate to={buildLoginRedirectUrl(`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`, location)} replace />
	}

	return <Outlet />
}

export default ProtectedRoute
